import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import moment from "moment";


export default {
    deepClone(obj) {
        var str, newobj = obj.constructor === Array ? [] : {};
        if (typeof obj !== 'object') {
            return;
        } else if (window.JSON) {
            str = JSON.stringify(obj), //序列化对象
                newobj = JSON.parse(str); //还原
        } else {//如果不支持以上方法
            for (var i in obj) {
                newobj[i] = typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i];
            }
        }
        return newobj;
    },
    exportExcel(fileName, sheetName, data, map) {
        fileName = fileName + '_' + moment().format('YYYYMMDD_HH_mm') + '.xlsx'
        var contents = this.getMapedDate(data, map);
        var wb = XLSX.utils.book_new(); //工作簿对象包含一SheetNames数组，以及一个表对象映射表名称到表对象。XLSX.utils.book_new实用函数创建一个新的工作簿对象。
        var ws = XLSX.utils.json_to_sheet(contents);//将JS对象数组转换为工作表。{ header: Object.values(fields) }
        wb.SheetNames.push(sheetName);
        wb.Sheets[sheetName] = ws;
        const defaultCellStyle = { alignment: { textRotation: 90 }, font: { name: "Verdana", sz: 18, color: "FF00FF88" }, fill: { fgColor: { rgb: "CCAA00" } } };//设置表格的样式
        var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary', cellStyles: true, defaultCellStyle: defaultCellStyle, showGridLines: false };  //写入的样式
        var wbout = XLSX.write(wb, wopts);
        var blob = new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, fileName);
    },
    exportExcelSean(fileName, sheetName, data, map) {
        fileName = fileName + '_' + moment().format('YYYYMMDD_HH_mm') + '.xlsx'
        var contents = this.getMapedDateSean(data, map);
        var wb = XLSX.utils.book_new(); //工作簿对象包含一SheetNames数组，以及一个表对象映射表名称到表对象。XLSX.utils.book_new实用函数创建一个新的工作簿对象。
        var ws = XLSX.utils.json_to_sheet(contents);//将JS对象数组转换为工作表。{ header: Object.values(fields) }
        wb.SheetNames.push(sheetName);
        wb.Sheets[sheetName] = ws;
        const defaultCellStyle = { alignment: { textRotation: 90 }, font: { name: "Verdana", sz: 18, color: "FF00FF88" }, fill: { fgColor: { rgb: "CCAA00" } } };//设置表格的样式
        var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary', cellStyles: true, defaultCellStyle: defaultCellStyle, showGridLines: false };  //写入的样式
        var wbout = XLSX.write(wb, wopts);
        var blob = new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, fileName);
    },
    s2ab(s) {
        if (typeof ArrayBuffer != 'undefined') {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }
        else {
            var buf = new Array(s.length);
            for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }
    },
    getMapedDate(data, map) {
        var res = [];
        data.forEach(d => {
            var r = {};
            map.forEach(m => {
                if (m.cb)
                    r[m.exh] = m.cb({}, {}, d[m.pt]);
                else
                    r[m.exh] = d[m.pt];
            });
            res.push(r);
        });
        return res;
    },
    getMapedDateSean(data, map) {
        var res = [];
        data.forEach(d => {
            var r = {};
            map.forEach(m => {
                if (m.cb)
                    r[m.exh] = m.cb({}, {}, d[m.exh]);
                else
                    r[m.exh] = d[m.exh];
            });
            res.push(r);
        });
        return res;
    },
    getArrLast(arr) {
        var last = arr[arr.length - 1];
        return last;
    },
    removeArrObj(_arr, _obj) {
        var length = _arr.length;
        for (var i = 0; i < length; i++) {
            if (_arr[i] == _obj) {
                if (i == 0) {
                    _arr.shift(); //删除并返回数组的第一个元素
                    return _arr;
                }
                else if (i == length - 1) {
                    _arr.pop();  //删除并返回数组的最后一个元素
                    return _arr;
                }
                else {
                    _arr.splice(i, 1); //删除下标为i的元素
                    return _arr;
                }
            }
        }
    },
    openUrl(url, id,target) {
        var a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('target',target?target: '_blank');
        a.setAttribute('id', id);
        // 防止反复添加  
        if (!document.getElementById(id)) {
            document.body.appendChild(a);
        }
        a.click();
    },

    getMediatype(url) {
        //获取最后一个.的位置
        var index = url.lastIndexOf(".");
        //获取后缀
        var ext = url.substr(index + 1);
        var isImg =  ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1;
        if(isImg) return 'img';
        var isVideo =  ['mp4', 'ogg', '3gp', 'flv', 'mkv', 'wav'].indexOf(ext.toLowerCase()) !== -1;
        if(isVideo) return 'video';
    },

    setFullContainer(isSet){
        var container_left = document.getElementById('container-item-left');
        var container_right = document.getElementById('container-item-right');
        if(isSet==true){
            console.info(isSet);
            
            container_left.style.display="none";
            container_right.style.width="100%";
        }
        else{
            console.info(isSet);
            container_left.style.display="block";
            container_right.style.width="calc(100% - 220px)";
        }
    },

   

}


// WEBPACK FOOTER //
// ./src/utils/libs.js